import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';

const Navigation: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.98)',
        borderBottom: '1px solid #1A1A1A',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar sx={{ padding: 0 }}>
          <Typography
            variant="h5"
            component="div"
            sx={{
              flexGrow: 1,
              fontWeight: 700,
              fontSize: '1.5rem',
              letterSpacing: '-0.025em',
            }}
          >
            <span style={{ color: '#1D9BF0' }}>V</span>ECTOR
          </Typography>
          <Box sx={{ display: { xs: 'none', sm: 'flex' }, gap: 2 }}>
            <Button color="inherit" onClick={() => scrollToSection('hero')}>
              Home
            </Button>
            <Button color="inherit" onClick={() => scrollToSection('about')}>
              About
            </Button>
            <Button color="inherit" onClick={() => scrollToSection('features')}>
              Features
            </Button>
            <Button color="inherit" onClick={() => scrollToSection('use-cases')}>
              Use Cases
            </Button>
            <Button color="inherit" onClick={() => scrollToSection('technical')}>
              Technical
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => scrollToSection('contact')}
            >
              Request Demo
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Navigation;